import React, { useState, useEffect } from 'react'
import { SelectEmployee } from '../SelectEmployee'

export const AssignEmployeesModal = ({ isOpen, onClose, employeesList = [], employeesId = [], onAssign, loading = false, folderId }) => {
	const [selectedEmployees, setSelectedEmployees] = useState(employeesId)
	const [error, setError] = useState('')

	useEffect(() => {
		if (isOpen) {
			if (employeesId.length === 0 && employeesList.length > 0) {
				setSelectedEmployees(employeesList.map(e => e.id))
			} else {
				setSelectedEmployees(employeesId)
			}
			setError('')
		}
	}, [isOpen, employeesId, employeesList])

	const handleAssign = () => {
		if (!selectedEmployees || selectedEmployees.length === 0) {
			setError('Selecione pelo menos um colaborador')
			return
		}
		setError('')
		onAssign(selectedEmployees, folderId)
	}

	if (!isOpen) return null

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-z-50 tw-flex tw-items-center tw-justify-center'>
			<div className='tw-bg-white tw-rounded-xl tw-shadow-lg tw-p-6 tw-w-[634px]'>
				<div className='tw-text-lg tw-font-medium tw-mb-6'>Relacionar colaboradores</div>
				<div className='tw-mb-4'>
					<SelectEmployee employees={employeesList} onSelect={setSelectedEmployees} selectedEmployees={selectedEmployees} multiple={true} />
				</div>
				{error && <div className='tw-text-red-500 tw-mb-2'>{error}</div>}
				<div className='tw-flex tw-justify-end tw-gap-3'>
					<div
						onClick={onClose}
						className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
						disabled={loading}
					>
						Cancelar
					</div>
					<div
						onClick={handleAssign}
						className={`tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg ${
							!selectedEmployees.length || loading ? 'tw-opacity-50' : ''
						}`}
						disabled={!selectedEmployees.length || loading}
						style={{ pointerEvents: !selectedEmployees.length || loading ? 'none' : 'auto' }}
					>
						{loading ? 'Salvando...' : 'Salvar'}
					</div>
				</div>
			</div>
		</div>
	)
}

export default AssignEmployeesModal
